import React from 'react';
import PropTypes from "prop-types";
import {Button, ColumnInformation, Components, InputInformation, InputList, PopupWindow, Size, Table} from "@utahdts/dts-react-common";
import Editor from "./Editor";
import {disableScroll, dispatchUpdateData, enableScroll} from "../misc/Shared";
import clone from 'clone';
import webservice from "../common/Webservice";
import reduxStore from "../app/ReduxStore";

const propTypes = {
	issues: PropTypes.array
};

const defaultProps = {
	issues: [],
};

class OtherIssues extends React.Component {
	constructor(props) {
		super(props);
		this.inputInformationChanged = this.inputInformationChanged.bind(this);

		this.state = {
			busy: false,
			editIssue: false,
			currentIssue: undefined,
			currentIssueIndex: undefined
		};

		this.columns = [
			new ColumnInformation({
				title: 'Description',
				field: 'issueName'
			})
		];

		this.inputs = [
			new InputInformation({
				field: 'issueName',
				label: 'Title:',
				type: Components.TEXT_INPUT,
				size: Size.FULL_WIDTH,
				onChange: this.inputInformationChanged,
				className: 'stack-form',
				maxLengthCounter: 100,
			}),
			new InputInformation({field: 'issueTypeId', label: 'Issue Type:', type: Components.SELECT_INPUT, size: Size.FULL_WIDTH, onChange: this.inputInformationChanged, className: 'stack-form', options: []}),
		];

		webservice.public.otherAction.otherActionTypes(reduxStore.getState().app.currentYear).then(data => this.inputs[1].options = data);
	}

	inputInformationChanged(field, value) {
		this.setState({currentIssue: Object.assign(clone(this.state.currentIssue), {[field]: value})});
	}

	isValid = () => {
		const valid = this.state.currentIssue.issueName && this.state.currentIssue.issueName.length <= 100;
		if (!valid) {
			alert('Title is too long. Please reduce its character count and try again.')
		}
		return valid;
	};

	createIssue() {
		if (this.isValid()) {
			webservice.admin.otherAction.create(this.state.currentIssue).then(this.closeModal());
		}
	}

	saveIssue() {
		if (this.isValid()) {
			webservice.admin.otherAction.update(this.state.currentIssue).then(this.closeModal());
		}
	}

	closeModal() {
		this.setState({busy: true}, () => {
				webservice.admin.tab.draft(reduxStore.getState().app.currentCobiId, reduxStore.getState().app.currentYear, reduxStore.getState().app.currentTab).then(data => {
					dispatchUpdateData({
							path: 'app.editing.issues.editor',
							field: 'issueText',
							value: data.issueText
						}
					);
					this.setState({editIssue: false, busy: false});
					enableScroll();
				});
			}
		);
	}

	render() {
		return (
			<React.Fragment>
				<div className="clearfix ">
					<div className="collapsible-section mt-spacing-large">
						<div className="clearfix collapsible-section__title">
							<h3 className="mt-spacing-large table-title">Other Action Items</h3>
						</div>
						<div>
							<Table
								columns={this.columns}
								list={this.props.issues}
								onRowClick={issue => this.setState({
									editIssue: true,
									currentIssue: {
										issueId: issue.issueId,
										cobiId: issue.cobiId,
										issueName: issue.issueName,
										issueTextHtml: issue.issueTextHtml,
										issueTypeId: issue.issueTypeId.toString(),
										isActive: issue.isActive,
										sessionFiscalYear: reduxStore.getState().app.currentYear,
									},
									currentIssueIndex: this.props.issues.map(i => i.issueId).indexOf(issue.issueId)
								}, () => disableScroll())}
								className="statutes issues issues-other clickable no-header"
							/>
						</div>
					</div>
					<Button label="Add action item"
							onClick={() => this.setState({
								editIssue: true,
								currentIssue: {
									cobiId: reduxStore.getState().app.currentCobiId,
									issueName: '',
									issueTextHtml: '',
									issueDescription: '',
									issueTypeId: undefined,
									isActive: true,
									sessionFiscalYear: reduxStore.getState().app.currentYear,
									displayOrder: this.props.issues.length,
								},
								currentIssueIndex: this.props.issues.length
							}, () => disableScroll())}
							className="primary float-right mtb-spacing"/>
				</div>
				{this.state.editIssue && <PopupWindow
					footerChildren={<React.Fragment>
						<Button label="Cancel" onClick={() => this.setState({editIssue: false}, () => enableScroll())} className="grey"/>
						<Button label="Save issue"
								className="blue"
								busy={this.state.busy}
								onClick={() => this.state.currentIssue.issueId ? this.saveIssue() : this.createIssue()}/>
					</React.Fragment>}
					className="popup-window--xlarge">
					<h3>Editing issue</h3>
					<InputList inputs={this.inputs} data={this.state.currentIssue}/>
					<div className="mt-spacing-small mb-spacing flex align-center">
						<label htmlFor="isActive">Active</label>
						<label className="switch ml-spacing-small">
							<input
								type="checkbox"
								name="isActive"
								checked={this.state.currentIssue.isActive}
								onChange={e => this.inputInformationChanged("isActive", e.target.checked)}
							/>
							<span className="slider round"/>
						</label>
					</div>
					<label>Description:</label>
					<Editor html={this.state.currentIssue.issueTextHtml}
							onChange={model => this.setState(prevState => ({
								currentIssue: {
									...prevState.currentIssue,
									issueTextHtml: model,
								}
							}))}
							counter={false}/>
				</PopupWindow>}
			</React.Fragment>
		);
	}
}

OtherIssues.propTypes = propTypes;
OtherIssues.defaultProps = defaultProps;

export default OtherIssues;
